import { Chat, ChatRef, WithNativeHTMLProps } from "@kalyzee/kast-web-sdk/web-components";
import React, { ForwardedRef, useEffect, useState } from "react";

import { ReactComponent as IconChatDisabled } from "../../../assets/icons/noChat.svg";
import "./Chat.css";
import styles from "./Chat.module.css";

export interface SecondaryScreenChatProps extends WithNativeHTMLProps<HTMLDivElement> {
  chatRef?: React.RefObject<ChatRef>;
  className?: string;
  style?: React.CSSProperties;
}

export interface SecondaryScreenChatRef {}

const SecondaryScreenChat = React.forwardRef(
  ({ chatRef, className, style, nativeProps }: SecondaryScreenChatProps, forwardRef: ForwardedRef<SecondaryScreenChatRef>) => {
    const [isDisabled, setDisabled] = useState<boolean>(false);

    // ---------------------------------------------------------------------- //
    // ---------------------------  EFFECTS ----------------------------- //
    // ---------------------------------------------------------------------- //

    useEffect(() => {
      if (!chatRef) return;
      const disableListener = chatRef.current?.addEventListener("disable", () => setDisabled(true));
      const enableListener = chatRef.current?.addEventListener("enable", () => setDisabled(false));
      setDisabled(chatRef.current?.isDisabled() ?? false);
      return () => {
        enableListener?.flush();
        disableListener?.flush();
      };
    }, [chatRef]);

    // ---------------------------------------------------------------------- //
    // ---------------------------  RENDER ----------------------------- //
    // ---------------------------------------------------------------------- //

    const classes = ["secondary_screen_chat", styles.container];
    if (className) classes.push(className);
    return (
      <div {...(nativeProps ?? {})} className={classes.join(" ")} style={style}>
        {/*<HeaderChat
            conversationsLength={0}
            tagStyle={{display: 'none'}}
            isChatActive={!isDisabled}
            disabledActiveChatButton
            disabledClearChatButton
            cx={styles.header}
          ></HeaderChat>*/}
        <div className={styles.content}>
          <Chat
            className={styles.chat}
            ref={chatRef}
            disableLoadMoreMessages
            messageParameters={{
              disableBubbleInteraction: true,
              disableDeletion: true,
              disableReaction: true,
              onAvatarClick: (msg) => {
                return false;
              },
            }}
            hideAvatarMaxRepetition={0}
          />

          {isDisabled && (
            <div className={styles.overlayDisabled}>
              <IconChatDisabled width={40} height={40} />
            </div>
          )}
        </div>
      </div>
    );
  }
);

export default SecondaryScreenChat;
